import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'

import { getActivityName, activityVideoId, activityVideoThumbnail } from 'store/entities/activity/selectors'
import WistiaVideo from 'app/domains/common/WistiaVideo'

const mapStateToProps = createStructuredSelector({
  videoId: activityVideoId,
  videoThumbnail: activityVideoThumbnail,
  alt: getActivityName,
})

export default connect(mapStateToProps)(WistiaVideo)
